















import Vue from 'vue';
import {Component, Prop} from 'vue-property-decorator';

type closeButton = {
  text: string;
  callBack?: () => void;
}
@Component
export default class Toast extends Vue {
  @Prop({
    type: [Boolean, Number], default: 3,
    validator(value: boolean | number): boolean {
      return value === false || typeof value === 'number';
    }
  }) autoClose?: boolean | number;
  @Prop(Boolean) enableHtml?: boolean;

  @Prop({
    default: () => {
      return {
        text: '关闭',
        callBack: undefined
      };
    }
  }) closeButton?: closeButton;

  @Prop({
    type: String, default: 'top', validator(value: string): boolean {
      return ['top', 'bottom', 'middle'].indexOf(value) >= 0;
    }
  }) position?: string;

  get toastClasses() {
    return {[`position-${this.position}`]: true};
  }

  mounted() {
    if (this.autoClose) {
      setTimeout(() => {
        this.close();
      }, (this.autoClose as number) * 1000);
    }
  }

  close() {
    this.$el.remove();
    this.$emit('close');
    this.$destroy();
  }

  onClickClose() {
    this.close();
    if (this.closeButton && typeof this.closeButton.callBack === 'function') {
      this.closeButton.callBack();
    }
  }
}
